import * as React from "react";
import PropTypes from "prop-types";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    root: {
        width: '100%',
    }
});

class TAccordian extends React.Component {

    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        items                 : PropTypes.array,
        content               : PropTypes.array,
        style                 : PropTypes.object,
        summaryStyle          : PropTypes.object,
    };

    static defaultProps = {
        items                 : ['Header 1', 'Header 2', 'Header 3'],
        content               : [<Typography>Content 1</Typography>, <Typography>Content 2</Typography>, <Typography>Content 3</Typography>],
        style                 : {},
        summaryStyle          : {},
    };
    
    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderContent = (items) => {
        return items;
    };

    renderPanels = () => {

        let s = [];

        for (let i = 0; i < this.props.items.length; i++) {
            s.push(
                <ExpansionPanel style={{borderTop: '1px solid rgb(220, 220, 220)', ...this.props.style}} key={'Accordian' + i}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={styles.heading} style={this.props.summaryStyle}>{this.props.items[i]}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{ display: 'block' }}>
                        {this.renderContent(this.props.content[i])}
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            );
        }

        return s;
    };

    render() {

        return (
            <div style={{width: '100%'}} >
                {this.renderPanels()}
            </div>
        );
    }
}

export default TAccordian;